module.exports = __webpack_public_path__ + "img/alex-smc.1b89f7ec.jpg";